import React, { useEffect, useState } from 'react';
export function AnalogClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Calculate rotation degrees
  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours() % 12;
  const secondDeg = seconds / 60 * 360;
  const minuteDeg = (minutes + seconds / 60) / 60 * 360;
  const hourDeg = (hours + minutes / 60) / 12 * 360;
  return <div className="flex flex-col items-center justify-center h-full p-6" data-id="element-17">
      <div className="relative w-32 h-32 rounded-full border-2 border-white/20 bg-black/40 shadow-inner mb-4" data-id="element-18">
        {/* Clock Face Markers */}
        {[...Array(12)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-white/40 rounded-full" style={{
        top: '50%',
        left: '50%',
        transform: `rotate(${i * 30}deg) translate(0, -56px)`
      }} data-id="element-19" />)}

        {/* Hour Hand */}
        <div className="absolute top-1/2 left-1/2 w-1 h-8 bg-white rounded-full origin-bottom -translate-x-1/2 -translate-y-full" style={{
        transform: `translateX(-50%) translateY(-100%) rotate(${hourDeg}deg)`
      }} data-id="element-20" />

        {/* Minute Hand */}
        <div className="absolute top-1/2 left-1/2 w-0.5 h-12 bg-gray-300 rounded-full origin-bottom -translate-x-1/2 -translate-y-full" style={{
        transform: `translateX(-50%) translateY(-100%) rotate(${minuteDeg}deg)`
      }} data-id="element-21" />

        {/* Second Hand */}
        <div className="absolute top-1/2 left-1/2 w-0.5 h-14 bg-red-500 rounded-full origin-bottom -translate-x-1/2 -translate-y-full" style={{
        transform: `translateX(-50%) translateY(-100%) rotate(${secondDeg}deg)`
      }} data-id="element-22" />

        {/* Center Dot */}
        <div className="absolute top-1/2 left-1/2 w-2 h-2 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 shadow-lg" data-id="element-23" />
      </div>

      <div className="text-center" data-id="element-24">
        <div className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-1" data-id="element-25">
          New York, NY
        </div>
        <div className="text-xl font-bold text-white tabular-nums" data-id="element-26">
          {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </div>
      </div>
    </div>;
}